import React from "react";

function MarginTradingEHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Margin Trading Crypto Exchange Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology provides comprehensive margin trading crypto
                    exchange development, enabling traders to leverage their
                    positions with advanced security, real-time market data, and
                    seamless user experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MarginTradingEHero;
